import { HeadCell } from "@/components/app/EnhancedTableHeader/type";
import { SubscriptionHistoryData } from "./type";

const headCells: HeadCell<SubscriptionHistoryData>[] = [
    {
        id: "planName",
        numeric: false,
        disablePadding: false,
        label: "Plan Name",
    },
    {
        id: "status",
        numeric: false,
        disablePadding: false,
        label: "Status",
    },
    {
        id: "startDate",
        numeric: false,
        disablePadding: false,
        label: "Start Date",
    },
    {
        id: "endDate",
        numeric: false,
        disablePadding: false,
        label: "End Date",
    },
    {
        id: "paymentStatus",
        numeric: false,
        disablePadding: false,
        label: "Payment Status",
    },
    {
        id: "paymentDate",
        numeric: false,
        disablePadding: false,
        label: "Payment Date",
    },
    {
        id: "source",
        numeric: false,
        disablePadding: false,
        label: "Source",
    },
];

export default headCells;
